import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';
import { KEYS_CHARCODE } from './../../editor-common';
import { DropdownModal, ListItemSection, ListItemSelect } from './../../toolbars-ui';

import { LayoutGridIconNew } from '../assets/icons/LayoutGridIconNew';
import { LayoutListIconNew } from '../assets/icons/LayoutListIconNew';
import {
  LAYOUT_DROPDOWN_OPTION_CUSTOMIZE_LAYOUT,
  LAYOUT_DROPDOWN_OPTION_GRID,
  LAYOUT_DROPDOWN_OPTION_LIST,
} from '../data-hooks';

type Props = {
  selectedLayout: SupportedLayouts;
  onLayoutClick: (commandKey: string) => void;
  onCustomizeButtonClick: () => void;
};

export const PollLayoutDropdown: React.FC<Props> = ({
  selectedLayout,
  onLayoutClick,
  onCustomizeButtonClick,
}) => {
  const { t, jsdomMode } = useContext(RicosContext) || {};

  const onKeyDown = (e: $TSFixMe, onClick: $TSFixMe) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      onClick();
      e.stopPropagation();
    }
  };

  const CustomizeButton = (
    <>
      <ListItemSection type={'divider'} />
      <ListItemSelect
        title={t('Poll_Mobile_Editor_Toolbar_Customize')}
        onClick={onCustomizeButtonClick}
        dataHook={LAYOUT_DROPDOWN_OPTION_CUSTOMIZE_LAYOUT}
        onKeyDown={e => onKeyDown(e, onCustomizeButtonClick)}
      />
    </>
  );

  return (
    <DropdownModal
      options={[
        ...Object.entries(dropdownOptions).map(([layout, { dataHook, icon: Icon, text }]) => {
          const onButtonClick = () => onLayoutClick(layout);
          return (
            <ListItemSelect
              key={layout}
              title={t(text)}
              dataHook={dataHook}
              prefix={<Icon />}
              selected={layout === selectedLayout}
              onClick={onButtonClick}
              onKeyDown={e => onKeyDown(e, onButtonClick)}
            />
          );
        }),
        CustomizeButton,
      ]}
      jsdomMode={jsdomMode}
    />
  );
};

export type SupportedLayouts = 'GRID' | 'LIST';

export const dropdownOptions: Record<
  SupportedLayouts,
  {
    text: string;
    icon: React.FC<{ size?: string | number }>;
    dataHook: string;
  }
> = {
  GRID: {
    text: 'Poll_PollSettings_Tab_Layout_Section_Answers_Layout_Grid',
    icon: LayoutGridIconNew,
    dataHook: LAYOUT_DROPDOWN_OPTION_GRID,
  },
  LIST: {
    text: 'Poll_PollSettings_Tab_Layout_Section_Answers_Layout_List',
    icon: LayoutListIconNew,
    dataHook: LAYOUT_DROPDOWN_OPTION_LIST,
  },
};
